import React from "react"
import SEO from "../components/seo"
import LanguageSelection from "../components/language-selection"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import { setLanguage } from "../redux/actions/languageActions"
import { connect } from "react-redux"
import PropTypes from "prop-types"
const locales = require("../i18n/constants")

/**
 *
 * Startpage for the application
 *
 * @param {Function} setLanguage redux function for handling language state
 * @param {Object} data Translations
 */
const IndexPage = ({
  setLanguage,
  data: {
    prismic: { allKeywordss, allFooters },
  },
}) => {
  setLanguage(locales["ca"])

  return (
    <Layout
      showCountry={false}
      hidePicker={true}
      keywords={allKeywordss}
      footer={allFooters}
      navigation={
        <LanguageSelection title={allKeywordss.edges[0].node.title[0].text} />
      }
    >
      <SEO />
    </Layout>
  )
}
IndexPage.propTypes = {
  setLanguage: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
}
const mapDispatchToProps = { setLanguage }

export default connect(null, mapDispatchToProps)(IndexPage)

export const pageQuery = graphql`
  query {
    prismic {
      allKeywordss(lang: "en-ca") {
        edges {
          node {
            title
            glossary
            news
            aboutus
            integritypolicy
            privacypolicy
            disclaimer
            resources
            contact
            about
          }
        }
      }
      allFooters(lang: "en-ca") {
        edges {
          node {
            about
            aboutus
            resources
            news
            dictionary
            legal
            disclaimer
            privacypolicy
            whatwedo
            whatwedotext
            responsiblegaming
            responsiblegamingtext
            contact
            contacttext
            bottomlinks
            _linkType
          }
        }
      }
    }
  }
`
